<template>
  <ul
    v-if="items"
    :style="[
      items.length > 1
        ? { columns: 1, 'column-gap': '20px', 'margin-bottom': '0px' }
        : '',
    ]"
  >
    <li v-for="(item, index) in slicedItems" :key="item.id">
      <slot name="item" :item="item" :index="index" />
    </li>
  </ul>
</template>

<script lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

export default defineComponent({
  name: 'OneColumnList',
  props: {
    items: {
      type: Array as PropType<Category[] | undefined>,
      required: true,
    },
    slice: {
      type: Number as PropType<number>,
      default: 4,
      validator: (propValue: number) => [3, 4, 5, 6, 7].includes(propValue),
    },
    filter: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
      type: Function as PropType<Function>,
      default: () => () => true,
    },
  },
  setup(props) {
    const itemsLength = props.slice
    const filteredItems = computed(
      () => props.items?.filter(() => props.filter()) || [],
    )
    const slicedItems = computed(() =>
      filteredItems.value.slice(0, itemsLength),
    )

    return {
      slicedItems,
    }
  },
})
</script>
